import { z } from 'zod';

import { DelinquentInterestSettingId, PaymentConfigId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateDelinquentInterestAppliedSideEffectContext = BaseLoanIdSideEffect.extend({
  paymentConfigId: PaymentConfigId.optional(),
  delinquentInterestSettingId: DelinquentInterestSettingId.optional(),
});

export const GenerateDelinquentInterestAppliedSideEffect = GenerateDelinquentInterestAppliedSideEffectContext.extend({
  type: z.literal('generateDelinquentInterestApplied'),
});
export type GenerateDelinquentInterestAppliedSideEffect = z.infer<typeof GenerateDelinquentInterestAppliedSideEffect>;
